type IProps = {
  name?: string;
  inputName?: string;
  type?: string;
  value?: string;
  placeholder?: string;
  error?: string;
  border?: boolean;
  label?: string;
  options?: { label: string; value: string }[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onFocus?: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  icon?: React.ReactNode;
  defaultValue?: string | number | readonly string[] | undefined;
  disabled?: boolean;
};

const Input: React.FC<IProps> = ({
  type = 'text',
  placeholder,
  inputName,
  value,
  error,
  border = false,
  label,
  options,
  onChange,
  onFocus,
  defaultValue,
  icon,
}) => {
  return (
    <div className="flex w-full flex-col space-y-2">
      {label && (
        <label htmlFor={inputName} className="text-xs text-clr-a1">
          {label}
        </label>
      )}

      <div
        className={`flex w-full items-center text-sm ${
          border ? 'border border-gray-300 px-4' : 'border-b border-gray-300'
        } py-3`}
      >
        <div className="flex w-full items-center">
          {options ? (
            <select
              id={inputName}
              name={inputName}
              value={value}
              onChange={onChange}
              className="w-full border-none bg-transparent text-clr-a1 focus:outline-none"
            >
              <option value="" disabled>
                {placeholder}
              </option>
              {options.map(option => (
                <option key={option.value} value={option.value} className="dark:bg-clr-2e">
                  {option.label}
                </option>
              ))}
            </select>
          ) : (
            <input
              id={inputName}
              name={inputName}
              type={type}
              value={value}
              defaultValue={defaultValue}
              placeholder={placeholder}
              onChange={onChange}
              onFocus={onFocus}
              className="w-full border-none bg-transparent text-clr-0a focus:outline-none dark:text-white"
            />
          )}
        </div>

        {icon && (
          <div className="ml-2 flex items-center">
            <div className="h-5 w-5 text-clr-6A dark:text-clr-a4">{icon}</div>
          </div>
        )}
      </div>

      {error && <span className="mt-1 text-sm text-red-500">{error}</span>}
    </div>
  );
};

export default Input;
